if (!customElements.get("product-description")) {
  customElements.define(
    "product-description",
    class ProductDescription extends HTMLElement {
      constructor() {
        super();
        this.descriptionContainer = this.querySelector(
          ".product-description-container"
        );
        this.expandButton = this.querySelector(".expand_description");
        this.minimizeButton = this.querySelector(".miniminze_description");

        if (
          !this.descriptionContainer ||
          !this.expandButton ||
          !this.minimizeButton
        )
          return;

        this.descriptionChildren = [...this.descriptionContainer.children];

        if (this.descriptionChildren.length > 1) {
          this.mininizeContent();

          this.expandButton.addEventListener(
            "click",
            this.expandContent.bind(this)
          );

          this.minimizeButton.addEventListener(
            "click",
            this.mininizeContent.bind(this)
          );
        }
      }
      mininizeContent() {
        this.descriptionContainer.classList.add("truncate_description");
        this.minimizeButton.classList.add("hidden");
        this.expandButton.classList.remove("hidden");

        this.descriptionChildren.forEach((element, index) => {
          if (index != 0) {
            element.classList.add("description_shortened");
            element.style.maxHeight = null;
          }
        });
      }
      expandContent() {
        this.descriptionContainer.classList.remove("truncate_description");
        this.expandButton.classList.add("hidden");
        this.minimizeButton.classList.remove("hidden");

        this.hiddenContents = [
          ...this.querySelectorAll(".description_shortened"),
        ];

        this.hiddenContents.forEach((el) => {
          el.style.maxHeight = el.scrollHeight + "px";
        });
      }
    }
  );
}
